'use client';
import React, { useRef, useCallback } from 'react';

/*
 * `toString` предотвращает попытку бандлера преобразовать вхождение к:
 * `import { useInsertionEffect } from 'react'`
 */ const useInsertionEffect = React['useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || ((fn)=>fn());
function useEffectEvent(action) {
    const ref = useRef(()=>{
        throw new Error('Cannot call an event handler while rendering.');
    });
    useSafeInsertionEffect(()=>{
        ref.current = action;
    });
    return useCallback((...args)=>ref.current == null ? void 0 : ref.current.call(ref, ...args), []);
}

export { useEffectEvent };
//# sourceMappingURL=useEffectEvent.js.map
